import React, { useCallback } from "react";

import { Cluster } from "@mapmycustomers/shared/types/map";
import { convertRegionToLatLngBounds } from "@mapmycustomers/shared/util/geo/GeoService";

import { Feature, useMap } from "@app/component/map/FeaturedMap/index";
import defaultIdGetter from "@app/util/defaultIdGetter";
import loggingService from "@app/util/logging";
import defaultMapEntryGeometryGetter from "@app/util/map/defaultMapEntryGeometryGetter";
import isValidMapEntry from "@app/util/map/isValidMapEntry";
import defaultClusterStyleGetter from "@app/util/map/markerStyles/defaultClusterStyleGetter";

const isDifferentCluster = (a: Cluster, b: Cluster) =>
  a.id !== b.id ||
  a.count !== b.count ||
  Math.abs((a.region!.latitude ?? 0) - (b.region!.latitude ?? 0)) > Number.EPSILON ||
  Math.abs((a.region!.longitude ?? 0) - (b.region!.longitude ?? 0)) > Number.EPSILON;

interface Props {
  clusters: Cluster[];
  styleGetter?: (item: Cluster) => google.maps.Data.StyleOptions;
  type?: string;
}

const ClusterFeature = ({
  clusters,
  styleGetter = defaultClusterStyleGetter,
  type = "clusters",
}: Props) => {
  const { map } = useMap();

  const handleClusterClick = useCallback(
    (cluster: Cluster) => {
      loggingService.debug("cluster clicked", cluster);
      const newBounds = convertRegionToLatLngBounds(cluster.region!);
      map.fitBounds(newBounds);
    },
    [map]
  );

  return (
    <Feature<Cluster>
      geometryGetter={defaultMapEntryGeometryGetter}
      idGetter={defaultIdGetter}
      isDifferent={isDifferentCluster}
      items={clusters.filter(isValidMapEntry)}
      onClick={handleClusterClick}
      styleGetter={styleGetter}
      type={type}
    />
  );
};

export default ClusterFeature;
